import { createFileRoute } from '@tanstack/react-router';
import Basics from 'src/pages/Organization/Branches/Basics';

export const Route = createFileRoute('/$organizationSlug/branches/$branchId/')({
  component: Basics,
});
